import {callsApi} from 'sources/api';
import SharingActions from 'actions/sharing/SharingActions';

/**
 * `ShareSource` implements interactions with sharing-related endpoints
 */
const ShareSource = {
  create: {
    remote(state, fileUpload, params) {
      return callsApi
        .post(`/share/${fileUpload.id}`, params)
        .then(response => [fileUpload, params, response]);
    },
    loading: SharingActions.shareFileUploadLoading,
    success: SharingActions.shareFileUploadSuccess,
    error: SharingActions.shareFileUploadError,
  },
};

export default ShareSource;
